export default () => (
  /**
   * Icone de um polígono.
   * Responsável por fazer polígonos no mapa.
   * Encontrado na ferramenta de inserir geometrias.
   */
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.99434" cy="9.5002" r="1.8" fill="#BEC7DC" />
    <circle cx="7.99434" cy="16.5002" r="1.8" fill="#BEC7DC" />
    <circle cx="15.9943" cy="11.3" r="1.8" fill="#BEC7DC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99043 4.3002C7.98454 4.3002 8.79043 3.49431 8.79043 2.5002C8.79043 1.50608 7.98454 0.700195 6.99043 0.700195C5.99632 0.700195 5.19043 1.50608 5.19043 2.5002C5.19043 3.49431 5.99632 4.3002 6.99043 4.3002ZM6.99033 3.39961C7.48739 3.39961 7.89033 2.99667 7.89033 2.49961C7.89033 2.00255 7.48739 1.59961 6.99033 1.59961C6.49328 1.59961 6.09033 2.00255 6.09033 2.49961C6.09033 2.99667 6.49328 3.39961 6.99033 3.39961Z"
      fill="#BEC7DC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.1718 1.61752L6.89803 1.34375L6.67493 1.65608C6.77311 1.61933 6.87941 1.59923 6.99041 1.59923C7.05254 1.59923 7.11321 1.60553 7.1718 1.61752ZM7.87212 2.31785C7.88411 2.37644 7.89041 2.4371 7.89041 2.49923C7.89041 2.99629 7.48746 3.39923 6.99041 3.39923C6.49335 3.39923 6.09041 2.99629 6.09041 2.49923C6.09041 2.49077 6.09053 2.48233 6.09076 2.47392L1.38343 9.06419L1.04199 9.5422L1.42429 9.98821L7.42429 16.9882L7.84414 17.478L8.39123 17.1361L16.3912 12.1361L17.1907 11.6364L16.5241 10.9698L7.87212 2.31785ZM2.94547 9.45803L7.08943 3.65648L14.7967 11.3638L8.14331 15.5222L2.94547 9.45803Z"
      fill="#BEC7DC"
    />
  </svg>
);
